import React from "react";
import { Typography, Card, CardContent } from "@mui/material";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { userDisplayName } from "../../utils/userDisplayName";
import "./IndependentRankingCard.css";

function IndependentRankingCard({ ranking }) {
  const dateLabel = ranking.creation_date
    ? format(new Date(ranking.creation_date), "MMM do, yyyy")
    : null;
  const authorName = userDisplayName(ranking.user) || "Unknown author";
  const officialName = ranking.official_ranking?.name;

  return (
    <Card className="independent-ranking-card">
      <CardContent className="independent-ranking-card-content">
        <div className="independent-ranking-card-description">
          <div className="independent-ranking-header">
            <Link to={`/independent-rankings/${ranking.independent_ranking_id}`}>
              {ranking.title}
            </Link>
          </div>
          {ranking.description && (
            <Typography component="p" className="independent-ranking-description">
              {ranking.description}
            </Typography>
          )}
          <div className="independent-ranking-subheader">
            <span className="independent-ranking-badge">Independent</span>
            {dateLabel && (
              <>
                <div className="sub-heading-divider" />
                <Typography component="p">{dateLabel}</Typography>
              </>
            )}
            <div className="sub-heading-divider" />
            <Typography component="p">{authorName}</Typography>
            {officialName && (
              <>
                <div className="sub-heading-divider" />
                <Typography component="p">{officialName}</Typography>
              </>
            )}
            <div className="sub-heading-divider" />
            <Typography component="p">Draft {ranking.draft_year}</Typography>
          </div>
        </div>
      </CardContent>
      <div className="independent-ranking-card-divider" />
    </Card>
  );
}

export default IndependentRankingCard;
